"use client";

// Locale-segment error boundary. Critical role: catches errors thrown
// in (app)/layout.tsx — most importantly `getCurrentUser()` re-throwing
// after lib/auth.ts exhausts its retry budget during a long uvicorn
// restart. Without a boundary one level up from (app)/, those errors
// bubble past the sibling (app)/error.tsx (which Next.js nests *inside*
// its same-segment layout) and hit Next's default crash UI.
//
// Lives under [locale]/ so it can render inside [locale]/layout.tsx
// (NextIntlClientProvider + theme + fonts still apply).

import { NetworkErrorRecovery } from "@/components/chrome/NetworkErrorRecovery";

export default function LocaleSegmentError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <NetworkErrorRecovery {...props} />;
}
